module.exports = "/_next/static/images/game-1-phone-gallery-08-21-1402-73714fddbe5629062ba336fe1ae7e07d.jpg";